import { isBootChecked, showSessionExpired } from "../components/layout/session-expired";
import { store } from "../store";
import { authChange } from "../store/auth";
import { HttpHandler } from "./http-handler";
import { HttpRequest as BaseHttpRequest } from "./http-request";

// Scopes of a user who is really signed in (same set app.tsx validates). The
// forgot / OTP / verify flows hold a pre-auth token with scope NONE.
const SIGNED_IN_SCOPES = ["AUTHORIZED", "RESTRICTED_SESSION", "FORGOT_PIN", "RESET_PIN"];
// Only an expired / revoked token is a «session expired»; other 401s (e.g.
// error.auth.no_role_assigned) would just loop through sign-in again.
const EXPIRY_KEYS = ["error.auth.session_expired", "error.auth.token_too_old"];
const isExpiry = (error: HttpHandler) =>
  [error?.message, error?.code, error?.payload?.message].some((v) => EXPIRY_KEYS.includes(v));

export class HttpRequest extends BaseHttpRequest {
  store = store;
  errorHandler = (statusCode: number, error: HttpHandler, api?: string): HttpHandler => {
    // Session-ийг зөвхөн auth/session service (/2fa/auth/*) 401 буцаахад л
    // цэвэрлэнэ — энэ нь токен өөрөө хүчингүй болсон гэсэн үг. Бизнес-модулийн
    // (ord/inv/biz/pricing гэх мэт) 401 нь тухайн модулийн эрхийн асуудал тул
    // зөвхөн тэр хүсэлтийг унагаах ёстой; бүх session-ийг устгаж хэрэглэгчийг
    // login руу шидэх ёсгүй (ингэснээр business сонголтод хүрэхээс өмнө гацдаг).
    if (statusCode === 401 && api?.startsWith("/2fa/auth")) {
      // Нэвтэрсэн хэрэглэгчийн токен хугацаа дууссан бол цонх үзүүлнэ (товч нь
      // session-ийг цэвэрлэж, буцах замыг хадгална). Boot шалгалтын үеийн 401,
      // нэвтрээгүй (NONE) токен, эрхгүй зэрэг бусад 401 бол хуучин хэвээр.
      const { accessToken, sessionScope } = store.getState().auth ?? {};
      const signedIn = !!accessToken && SIGNED_IN_SCOPES.includes(sessionScope || "");
      if (isBootChecked() && signedIn && isExpiry(error)) showSessionExpired();
      else store.dispatch(authChange());
    }
    throw error;
  };
}
